// extracted by mini-css-extract-plugin
export default {"checkbox":"Checkbox_checkbox__r157h","disabled":"Checkbox_disabled__Eqco1","check":"Checkbox_check__auD2G","on":"Checkbox_on__x2o13"};